import { watch } from 'vue';
import { useRoute } from 'vue-router';

export function useUseCaseRouterHook() {
  const route = useRoute();

  watch(
    () => route.fullPath,
    (value) => {
      // 有可能后面还需要传其他参数，构建个对象给他
      const params = {
        router: value,
      };
      window?.parent?.postMessage(JSON.stringify(params), import.meta.env.VITE_GLOB_DTS);
    }
  );
}
